import { Grid, gridClasses, styled, Typography, type TypographyProps } from 'ui';

export const DetailsSection = styled('div')(({ theme }) => ({
  height: '100%',
  padding: theme.spacing(2.5),
}));

type Props = TypographyProps & {
  type: 'default' | 'muted';
};
export const MatchedSiteMaterialDetailsSectionTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'type',
})<Pick<Props, 'type'>>(({ theme, type }) => ({
  color: type === 'muted' ? theme.palette.text.secondary : theme.palette.text.primary,
  fontWeight: type === 'muted' ? 'normal' : 'bold',
  marginBottom: theme.spacing(2),
}));

export const MatchedSiteMaterialGridContainer = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  borderRadius: theme.spacing(1),
  [`&.${gridClasses.item}`]: {
    padding: 0,
  },
}));
